module.exports = __webpack_public_path__ + "static/media/profile1.2dca4c77.jpg";